function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "icon/outlined/editor/delete",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "931nv7qwca"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/outlined/editor/delete (clip mask)",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/outlined/editor/delete (clip mask)",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "icon/outlined/editor/delete",
    style: {
      clipPath: "url(#931nv7qwca)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "icon/outlined/editor/delete (clip group)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/outlined/editor/delete (style)",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.32 18.75H3.68a1.5 1.5 0 0 1-1.5-1.429L1.6 5.063H.187A.187.187 0 0 1 0 4.875v-.75a.751.751 0 0 1 .75-.75h3V1.5A1.5 1.5 0 0 1 5.25 0h7.5a1.5 1.5 0 0 1 1.5 1.5v1.874h3a.751.751 0 0 1 .75.75v.751a.187.187 0 0 1-.187.187H16.4l-.582 12.258a1.5 1.5 0 0 1-1.498 1.43zM3.293 5.063l.567 12h10.28l.567-12zm2.145-1.688h7.124V1.689h.188a.188.188 0 0 1-.188-.187v.187H5.438z",
    transform: "translate(3 2.625)",
    style: {
      fill: "#current"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.16d0a271b4695b963a32fd58f0648e4d.svg";
export { ForwardRef as ReactComponent };